import { memo, type ReactNode } from 'react';
import { DialogProps } from '@radix-ui/react-dialog';
import { useTranslation } from 'react-i18next';

import {
  DialogHeader,
  Dialog,
  DialogTrigger,
  DialogTitle,
  DialogContent,
  DialogFooter,
  DialogClose,
  Button,
} from '@/components/ui';
import MarketsTable from '@/features/markets/components/markets-table';

interface EditWatchListProps extends DialogProps {
  children?: ReactNode;
}

export default function EditWatchList({
  children,
  ...dialogProps
}: EditWatchListProps) {
  const { t } = useTranslation();

  return (
    <Dialog {...dialogProps}>
      {children && <DialogTrigger>{children}</DialogTrigger>}

      <DialogContent className="gap-0 sm:max-w-2xl">
        <DialogHeader className="px-5 pb-4 pt-6">
          <DialogTitle>{t('editWatchList.title')}</DialogTitle>
        </DialogHeader>

        <div>
          <div className="relative w-full rounded-br-md border-t border-border">
            <MarketsTable
              id="markets-watchList"
              variant="watchList"
              containerClassName="relative h-[336px]"
              tableClassName="[&_td]:text-base [&_td:last-child>div]:ml-auto sm:[&_td:first-child]:pl-6 sm:[&_td:last-child]:pr-6 [&_td]:h-auto [&_td]:py-2 sm:[&_th:first-child]:pl-6 sm:[&_th:last-child]:pr-6 [&_th]:h-12 [&_th]:py-0 [&_tr]:cursor-pointer"
              isInfiniteScroll
              infiniteScrollEstimateRowSize={36}
              infiniteScrollOverscan={10}
              disableDelay
            />
          </div>
        </div>

        <DialogFooter>
          <DialogClose asChild>
            <Button
              size="lg"
              className="h-14 w-full rounded-none font-mono text-lg font-normal uppercase tracking-wider"
            >
              {t('editWatchList.done')}
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
